export function createXLSheetdata(ticketList) {
    ticketList.find((ticketDetails, index) => {                


                ticketList[index].Ticket_Id=ticketList[index].id
                delete ticketList[index]['id']

                ticketList[index].Created=ticketList[index].created
                delete ticketList[index]['created']


                ticketList[index].Store_Id=ticketList[index].urbanpiper_id                
                delete ticketList[index]['urbanpiper_id']

                ticketList[index].Store_Name=ticketList[index].store_name
                delete ticketList[index]['store_name']

                ticketList[index].Brand=ticketList[index].brand_name
                delete ticketList[index]['brand_name']

                ticketList[index].Kitchen_Code=ticketList[index].kitchen_code
                delete ticketList[index]['kitchen_code']

                ticketList[index].Platform_Name=ticketList[index].platform_name
                delete ticketList[index]['platform_name']

                ticketList[index].Reason=ticketList[index].reason
                delete ticketList[index]['reason']

                ticketList[index].Remarks=ticketList[index].remarks
                delete ticketList[index]['remarks']

                ticketList[index].Status=ticketList[index].status
                delete ticketList[index]['status']

                ticketList[index].Hold_till=ticketList[index].hold_till
                delete ticketList[index]['hold_till']

                ticketList[index].Resolver=ticketList[index].resolver
                delete ticketList[index]['resolver']
               

                ticketList[index].ModifiedOn=ticketList[index].modified
                delete ticketList[index]['modified']

                delete ticketList[index]['urbanpiper_id']
                delete ticketList[index]['remarks']
                delete ticketList[index]['kitchen_name']
                delete ticketList[index]['kitchen_contact_no']
                delete ticketList[index]['cluster_contact_no']
                delete ticketList[index]['kitchen_manager_contact_no']
                delete ticketList[index]['city_name']
                delete ticketList[index]['type']
                delete ticketList[index]['status']
                delete ticketList[index]['modified']
                delete ticketList[index]['hold_till']


                return false
            })   
            return ticketList
}

 
                           
export function createStoreXLSheetdata(storesData) {
    storesData.find((ticketDetails, index) => {
                
            storesData[index].StoreId=storesData[index].id
            delete storesData[index]['id']
                
            storesData[index].StoreName=storesData[index].store_name
            delete storesData[index]['store_name']

            storesData[index].Status=storesData[index].status
            delete storesData[index]['status']

            storesData[index].BusinessStatus=storesData[index].business_status
            delete storesData[index]['business_status']

            storesData[index].BusinessRemarks=storesData[index].business_remarks
            delete storesData[index]['business_remarks']
            
            storesData[index].Kitchen=storesData[index].kitchen_name
            delete storesData[index]['kitchen_name']
            
            storesData[index].KitchenCode=storesData[index].kitchen_code
            delete storesData[index]['kitchen_code']
            
            storesData[index].CityName=storesData[index].city_name
            delete storesData[index]['city_name']

            storesData[index].Brand=storesData[index].brand_name
            delete storesData[index]['brand_name']

            storesData[index].Platforms=storesData[index].store_platforms
            delete storesData[index]['store_platforms']


            
            storesData[index].UrbanpiperId=storesData[index].urbanpiper_id
            delete storesData[index]['urbanpiper_id']
            
            
            storesData[index].startTime=storesData[index].start_time
            delete storesData[index]['start_time']
            
            storesData[index].endEime=storesData[index].end_time
            delete storesData[index]['end_time']
            
            if(storesData[index].end_day){
                storesData[index].endDay="NEXT_DAY"
            }else{
                storesData[index].endDay="CURRENT_DAY"
            }
            
            delete storesData[index]['end_day']

            return false

            })   
            return storesData
}



// WEBPACK FOOTER //
// ./src/modules/Stores/services/helpers.js